import React, { useState, useContext, useEffect } from "react";
import styles from "./styles/SideSettlement.module.css";
import DataContext from "../../../context/DataContext";
import { formatDateToLocalDate } from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
// import { ReactComponent as Pointer } from "../../../assets/circle-arrow-2.svg";
import { ReactComponent as Pointer } from "../../../assets/triangle.svg";
import useNumberFormat from "../../../hooks/useNumberFormat";
import { ReactComponent as IconClock } from "../../../assets/clock.svg";
import { ReactComponent as IconGavel } from "../../../assets/gavel.svg";
import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";

/**
 * SideTicket component
 */
const SideSettlement = ({
    ticket,

    currency,

    handleCheckSettlement,
    selectedSettlements,
    handleClickedTicket,
    clickedTicket,
}) => {
    const {
        setCurrentTicket,
        setTicketType,
        isPayHover,
        selectedTickets,
        setSelectedInstalments,
        selectedInstalments,
        isInstallemtHover,
        connection,
    } = useContext(DataContext);
    const [total, setTotal] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const formatNum = useNumberFormat();

    useEffect(() => {
        const current = selectedSettlements?.filter(
            (item) => item === ticket?.caseNo,
        );

        setIsChecked(current?.length > 0);
    }, [selectedSettlements]);

    useEffect(() => {
        setSelectedItems(getSelectedItems());
    }, [selectedInstalments]);

    const filterSelectedInstalments = () => {
        const selectedArray = selectedInstalments.map(
            (item) => item.instalmentId,
        );
        return ticket?.settlementTransactionItems.filter((item) =>
            selectedArray.includes(item.id.toString()),
        );
    };

    const onClickHandle = () => {
        setCurrentTicket(ticket);
        setTicketType(1);

        handleClickedTicket(ticket?.caseNo);
    };

    const calculateSettlementValue = () => {
        const value =
            selectedItems &&
            selectedItems.length &&
            selectedItems.reduce(
                (acc, item) => acc + parseFloat(item.netAmount),
                0,
            );
        return Number(value || 0).toFixed(2);
    };

    useEffect(() => {
        setTotal(calculateSettlementValue());
    }, [selectedItems]);

    const getMustPaidItems = () => {
        const filteredItems =
            ticket?.settlementTransactionItems.filter(
                (item) => item.status === 0 || item.status === 1,
            ) || [];

        return filteredItems;
    };

    const getSelectedItems = () => {
        const selectedArray = selectedInstalments.map((item) =>
            item.instalmentId.toString(),
        );
        return ticket?.settlementTransactionItems.filter((item) =>
            selectedArray.includes(item.id.toString()),
        );
    };

    const selectMandatoryInstallment = () => {
        if (isChecked) {
            const mustPaid = getMustPaidItems();

            if (mustPaid.length) {
                mustPaid.forEach((item) =>
                    setSelectedInstalments((prev) => [
                        ...prev,
                        {
                            instalmentId: item?.id.toString(),
                            amount: item?.netAmount.toString(),
                            instalmentInfo: item?.txt.toString(),
                            instalmentDate: item?.dateAndTime.toString(),
                        },
                    ]),
                );
            } else {
                const firstInstalment = ticket?.settlementTransactionItems[0];

                setSelectedInstalments((prev) => [
                    ...prev,
                    {
                        instalmentId: firstInstalment?.id.toString(),
                        amount: firstInstalment?.netAmount.toString(),
                        instalmentInfo: firstInstalment?.txt.toString(),
                        instalmentDate: firstInstalment?.dateAndTime.toString(),
                    },
                ]);
            }
        } else {
            setSelectedInstalments((prev) =>
                prev.filter(
                    (trans) =>
                        !selectedItems.some(
                            (item) => trans.instalmentId === item.id.toString(),
                        ),
                ),
            );
        }
    };

    useEffect(() => {
        selectMandatoryInstallment();
    }, [isChecked]);

    const handleLocalCheck = (event) => {
        event.stopPropagation();
        handleCheckSettlement(event);
        // selectMandatoryInstallment();
    };

    return (
        <button
            className={`${styles.main_ticket_container} ${
                clickedTicket === ticket?.caseNo && styles.clicked
            } flex-container`}
            onClick={() => onClickHandle()}
        >
            <div className={`${styles.input_check_container} flex-container`}>
                {connection?.isPayment ? (
                    <input
                        className={`${styles.input_check_element}`}
                        type="checkbox"
                        name={ticket?.caseNo || ""}
                        id={ticket?.caseNo || ""}
                        value={total || 0}
                        onClick={handleLocalCheck}
                        checked={isChecked}
                        readOnly
                    />
                ) : (
                    <></>
                )}

                <Pointer
                    className={`${styles.input_check_highlight}  ${
                        (isPayHover &&
                            !selectedInstalments.length &&
                            !selectedTickets.length) ||
                        (isInstallemtHover === ticket?.caseNo &&
                            !selectedSettlements.includes(ticket?.caseNo))
                            ? styles.arrowFadeIn
                            : styles.arrowFadeOut
                    } `}
                />

                <label
                    className={`${styles.input_check_label}`}
                    htmlFor={ticket?.caseNo}
                    aria-label={`Check input for settlement ${ticket?.caseNo}`}
                ></label>
            </div>

            <div className={`${styles.info_container} v-flex-container`}>
                <div
                    className={`${styles.ticket_info} ${styles.settlement_amount_container}  ${styles.ticket_hide_info} flex-container`}
                >
                    <span>
                        <IconBill
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    <div
                        className={`${styles.settlement_amount}  v-flex-container`}
                    >
                        <div>{`${currency}${formatNum(total)} /\u00A0`}</div>
                        <div>
                            {` ${currency}${formatNum(
                                ticket?.remainingAmount,
                            )}`}
                        </div>
                    </div>
                </div>

                <div className={`${styles.ticket_info}  flex-container`}>
                    <span>
                        <IconGavel
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {ticket?.caseNo}
                </div>

                <div
                    className={`${styles.ticket_info} ${styles.ticket_hide_info}  flex-container`}
                >
                    <span>
                        <IconClock
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {formatDateToLocalDate(
                        ticket?.settlementTransactionItems?.[0]?.dateAndTime,
                    )}
                </div>
            </div>
        </button>
    );
};

export default SideSettlement;
